import { ApiService } from '../../services/api_service';
import { DataService } from '../../services/data_service';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { getWetterstation } from './functions/getWetterstation';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { onFormChangeUniversal } from './functions/onFormChange';
import * as React from 'react';
import { StandorteDetail } from './detail/StandorteDetail';
import { TriggerService } from '../../core/trigger/trigger_service';
import { validateFieldUniversal } from './functions/validateField';
import { WActionButton } from '../../core/elements/WActionButton';
import { WFormData } from '../../core/forms/WFormData';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';
import { WMap } from './map/Wmap';
import { StandorteGruppen } from './detail/StandorteGruppen';
import * as config from '../../wips.config.js';
import { hasFeature } from '../../control/hasFeature';
import { Features } from '../../control/features';

export interface DateneingabeBetrieblicheDatenStandortGebaeudeProps {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

export interface DateneingabeBetrieblicheDatenStandortGebaeudeState {
    rowForDialog: any;
    rowForGps: any;
    showDlgStandorteGruppen: boolean;
}

export class DateneingabeBetrieblicheDatenStandortGebaeude extends
    React.Component<DateneingabeBetrieblicheDatenStandortGebaeudeProps, DateneingabeBetrieblicheDatenStandortGebaeudeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            rowForDialog: undefined,
            rowForGps: undefined,
            showDlgStandorteGruppen: false
        };

        this.onAfterClose = this.onAfterClose.bind(this);
        this.onDataLoaded = this.onDataLoaded.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.onFormChangeInteractive = this.onFormChangeInteractive.bind(this);
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
        this.callBeforeDelete = this.callBeforeDelete.bind(this);
        this.setUnternehmensdatenInHauptsitz = this.setUnternehmensdatenInHauptsitz.bind(this);

        // private enableStandorteGruppen = config.devFeaturesMap && config.devFeaturesMap.N118_STANDORT_GRUPPIERUNG ? true : false;
        this.enableStandorteGruppen = hasFeature(Features.STANDORT_GRUPPEN, this.apiService.getBereichKey());
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private lastAdressString: string;
    private enableStandorteGruppen: boolean = false;

    componentDidMount(): void {
        this.setUnternehmensdatenInHauptsitz();
    }

    onAfterClose(): void {
        const routing = this.props.routing;
        if (routing.standort) {
            routing.standort = undefined;
            this.props.onRoutingChange(routing);
        }
        this.setState({ rowForDialog: undefined });
    }

    onDataLoaded(rows: Array<any>): void {
        // console.log('Standorte Loaded: ', rows, this.props.routing);
        if (this.props.routing && this.props.routing[IDs.ENT_STANDORT]) {
            const rowFound = rows.find((row: any) => row.tid === this.props.routing[IDs.ENT_STANDORT]);

            if (rowFound) {
                this.setState({ rowForDialog: rowFound });
            }
        }
    }

    onFormChange(WFormData: any): void {
        onFormChangeUniversal(IDs.ENT_STANDORT, WFormData, this, this.props.data);
    }

    async onFormChangeInteractive(formData: WFormData, onValueChange: (name: string, value: any) => void): Promise<void> {
        this.lastAdressString = await getWetterstation(this.props.data, this.lastAdressString, formData, onValueChange);
    }

    preFilter(data: Array<any>): any {
        const { standortSelected } = this.props;
        data = data.filter((item: any) => +item.standort_typ_tid_orig !== 5 && +item.standort_typ_tid_orig !== 6);
        return standortSelected
            ? data.filter((item: any) => (+item.tid || null) === standortSelected.tid)
            : data;
    }

    render(): JSX.Element {
        if (!this.props.data) {
            return null;
        }
        const isAdmin: boolean = this.apiService.isAdmin() || false;
        const customActions = [
            {
                label: 'Standort bearbeiten',
                key: 'edit',
                func: (row: any) => this.setState({ rowForDialog: row }),
                info: 'Standort bearbeiten'
            },
            {
                label: 'GPS-Verortung',
                key: 'map_open',
                func: (row: any) => this.setState({ rowForGps: row }),
                info: 'GPS-Verortung'
            }
        ];

        if (!isAdmin) {
            delete customActions[1];
        }
        const tblKey = this.props.data[IDs.ENT_STANDORT].map((o: any) => o.ort).join('_');
        // console.log('RenderStandorte', this.props.data[IDs.ENT_STANDORT]);
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_STANDORT}
                    module={IDs.MOD_ETOOL}
                    key={tblKey}
                    data={this.props.data[IDs.ENT_STANDORT]}
                    actions={['add', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    addLabel={ApiService.bereichKey === 'kommunalverwaltung' ? 'Neue Kategorie erfassen' : 'Neuen Standort erfassen'}
                    customActions={customActions}
                    customFormConfig={{
                        energiedaten_erfassen: { hidden: true },
                        standort_tid: { hidden: true },
                        datum_von: { hidden: true },
                        datum_bis: { hidden: true },
                        gruppe: this.enableStandorteGruppen ? {} : { hidden: true }
                    }}
                    hiddenColumns={[
                        'standort_tid', 'datum_von', 'datum_bis',
                        ...(this.enableStandorteGruppen ? [] : ['gruppe'])
                    ]}
                    onFormChange={this.onFormChange}
                    onFormChangeInteractive={this.onFormChangeInteractive}
                    validateField={this.validateField}
                    validRestriction='stop'
                    disableFieldSelectDefaultOptions={{
                        standort_typ_tid: true,
                        energiedaten_erfassen: true
                    }}
                    formPreset={{
                        standort_typ_tid: 2
                    }}
                    preFilterFunction={this.preFilter}
                    showColumnsHelp={true}
                    onDataLoaded={this.onDataLoaded} // Aktuell nur fürs Routing
                    // externalHeaderElements={[<WActionButton
                    //     label='Unternehmensdaten für Hauptsitz übernehmen'
                    //     insideText='Unternehmensdaten für Hauptsitz übernehmen'
                    //     tooltip='Unternehmensdaten für Hauptsitz übernehmen'
                    //     key='copy'
                    //     action='copy'
                    //     onAction={this.setUnternehmensdatenInHauptsitz}
                    // />]}
                    externalHeaderElements={[this.renderHeaderButtons()]}
                    formSimpleValidationMsg={['energiedaten_erfassen']}
                    globalData={this.props.data}
                    bundleFilterFunc={(bundle: any) => {
                        if (bundle && Array.isArray(bundle.standort_typ_tid)) {
                            bundle.standort_typ_tid = bundle.standort_typ_tid.filter((item: any) => +item.tid !== 5 && +item.tid !== 6);
                        }
                        return bundle;
                    }}
                    callBeforeDelete={this.callBeforeDelete}
                    // onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_STANDORT)}
                    onAfterAction={(action: string) => {
                        if (action === 'saveDone' || action === 'delDone') {
                            this.triggerService.fire('reload', IDs.ENT_STANDORT);
                        }
                    }}
                />
                {this.state.rowForDialog &&
                    <div>
                        <DialogWrapper2
                            width={-1}
                            onAfterClose={this.onAfterClose}
                        >
                            <StandorteDetail
                                data={this.props.data}
                                onRoutingChange={this.props.onRoutingChange}
                                routing={this.props.routing}
                                standortSelected={this.state.rowForDialog}
                            />
                            <div style={{ textAlign: 'right', marginRight: 4 }}>
                                {this.renderCloseButton()}
                            </div>
                        </DialogWrapper2>
                    </div>
                }
                {this.state.rowForGps &&
                    <div>
                        <DialogWrapper2
                            width={530}
                            onAfterClose={() => this.setState({ rowForGps: undefined })}
                        >
                            <WMap
                                lat={this.state.rowForGps.latitude ? this.state.rowForGps.latitude : null}
                                long={this.state.rowForGps.longitude ? this.state.rowForGps.longitude : null}
                                data={this.state.rowForGps}
                                entity={IDs.ENT_STANDORT}
                                edittable={true}
                                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_STANDORT)}
                            />
                        </DialogWrapper2>
                    </div>
                }
                {this.state.showDlgStandorteGruppen && this.renderDlgStandorteGruppen()}
            </div>
        );
    }

    callBeforeDelete(row: any, callback: () => void): void {
        const veranstaltungFnd = this.props.data[IDs.ENT_STANDORT].find((v: any) => v.tid !== row.tid
            && v.standort_typ_tid_orig === 5 /* Veranstaltung - eigener Standort */ && v.standort_tid_orig === row.tid);
        if (veranstaltungFnd) {
            alert(`Dieser Standort darf nicht gelöscht werden, da dem Standort die Veranstaltung "${veranstaltungFnd.name}" zugeordnet ist.`);
        } else {
            callback();
        }
    }

    setUnternehmensdatenInHauptsitz(): void {
        const { data } = this.props;
        if (Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN]) && data[IDs.ENT_UNTERNEHMENSDATEN].length > 0 &&
            Array.isArray(data[IDs.ENT_STANDORT]) && data[IDs.ENT_STANDORT].length > 0) {
            const unt = data[IDs.ENT_UNTERNEHMENSDATEN][0];
            const hauptList = data[IDs.ENT_STANDORT]
                .filter((s: any) => s.standort_typ_tid_orig === 1 &&
                    (s.strasse !== unt.strasse || s.hausnummer !== unt.hausnummer || s.ort !== unt.ort || s.plz !== unt.plz))
                .map((s: any) => {
                    const row: any = {
                        strasse: s.strasse,
                        hausnummer: s.hausnummer,
                        ort: s.ort,
                        plz: s.plz,
                        ort_gtz: s.ort_gtz,
                    };
                    Object.keys(row).forEach((k: string) => {
                        if (!row[k] && unt[k]) {
                            row[k] = unt[k];
                        }
                    });
                    row.tid = s.tid;
                    return row;
                });
            if (hauptList.length > 0) {
                hauptList.forEach((h: any) => {
                    const idx = data[IDs.ENT_STANDORT].findIndex((s: any) => s.tid === h.tid);
                    if (idx >= 0) {
                        const dataOrig = data[IDs.ENT_STANDORT][idx];
                        data[IDs.ENT_STANDORT][idx] = { ...dataOrig, ...h };
                    }
                });
                this.dataService.saveDataList(IDs.ENT_STANDORT, hauptList, () => {
                    this.triggerService.fire('reload', IDs.ENT_STANDORT);
                }, IDs.MOD_ETOOL);
            }
        }
    }

    renderCloseButton(): JSX.Element {
        return (
            <WActionButton
                label='Schließen'
                insideText='Schließen'
                key='close'
                action='delete'
                onAction={this.onAfterClose}
            />
        );
    }

    renderHeaderButtons(): JSX.Element {
        return (
            this.enableStandorteGruppen ?
                <WActionButton
                    label='Standort-Gruppen verwalten'
                    insideText={ApiService.bereichKey === 'kommunalverwaltung' ? 'Kategorie-Gruppen verwalten' : 'Standort-Gruppen verwalten'}
                    tooltip={ApiService.bereichKey === 'kommunalverwaltung' ? 'Kategorie-Gruppen verwalten' : 'Standort-Gruppen verwalten'}
                    key='config'
                    action='config'
                    onAction={() => this.setState({ showDlgStandorteGruppen: true })}
                />
                : null
        );
    }

    renderDlgStandorteGruppen(): JSX.Element {
        return (
            <div>
                <DialogWrapper2
                    width={-1}
                    onAfterClose={() => this.setState({ showDlgStandorteGruppen: false })}
                >
                    <StandorteGruppen />
                </DialogWrapper2>
            </div >
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_STANDORT, key, value, data, onValueChange, this.props.data);
    }
}
